import { render } from "./FederalTax.vue?vue&type=template&id=3bd3af06&scoped=true"
import script from "./FederalTax.vue?vue&type=script&lang=js"
export * from "./FederalTax.vue?vue&type=script&lang=js"

import "./FederalTax.vue?vue&type=style&index=0&id=3bd3af06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd3af06"]])

export default __exports__